import PropTypes from "prop-types";

export default function AdminActions({
                                         handleResetPasswordLink,
                                         handleVerifyEmailLink,
                                         handleDeleteAccount,
                                         registering,
                                         auth0Details,
                                         user,
                                         hasDeleteAccess
                                     }) {
    const email = auth0Details?.email;

    return (
        <div>
            <h4
                id="sub_head"
                style={{
                    fontFamily: "A Love of Thunder",
                    color: "#007935",
                    marginBottom: "10px"
                }}
            >
                Admin Controls
            </h4>

            <div
                style={{
                    background: "#fff",
                    borderRadius: "12px",
                    padding: "20px",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px"
                }}
            >
                <div>
                    <h6 id="note">
                        Send password reset link to the customer's email
                    </h6>

                    <div
                        className="form-group"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px"
                        }}
                    >
                        <input
                            type="text"
                            className="form-control"
                            value={email || "Email not found to send link."}
                            readOnly
                        />

                        <button
                            type="button"
                            id="sub_btn"
                            onClick={handleResetPasswordLink}
                            disabled={registering}
                            style={{
                                backgroundColor: "#137c00",
                                height: "35px",
                                fontSize: "1.2em",
                                whiteSpace: "nowrap",
                                width: "200px"
                            }}
                        >
                            Send Password Link{" "}
                            {registering && (
                                <i className="fa fa-spinner fa-spin" />
                            )}
                        </button>
                    </div>
                </div>

                <hr style={{ margin: 0 }} />

                <div>
                    <h6 id="note">
                        Send email verification link to the customer
                    </h6>

                    <div
                        className="form-group"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px"
                        }}
                    >
                        <input
                            type="text"
                            className="form-control"
                            value={email || "Email not found to send link."}
                            readOnly
                        />

                        <button
                            type="button"
                            id="sub_btn"
                            onClick={handleVerifyEmailLink}
                            disabled={registering}
                            style={{
                                backgroundColor: "#137c00",
                                height: "35px",
                                fontSize: "1.2em",
                                whiteSpace: "nowrap",
                                width: "200px"
                            }}
                        >
                            Verify Email Link{" "}
                            {registering && (
                                <i className="fa fa-spinner fa-spin" />
                            )}
                        </button>
                    </div>
                </div>

                <hr style={{ margin: 0 }} />

                {!!hasDeleteAccess && (
                    <div>
                        <h6 id="note">Admin delete action</h6>

                        <div
                            className="form-group"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px"
                            }}
                        >
                            <input
                                type="text"
                                className="form-control"
                                value={user?.email || "Account not found."}
                                readOnly
                            />

                            <button
                                type="button"
                                id="sub_btn"
                                onClick={handleDeleteAccount}
                                disabled={registering}
                                style={{
                                    backgroundColor: "#dc3545",
                                    height: "35px",
                                    fontSize: "1.2em",
                                    whiteSpace: "nowrap",
                                    width: "200px"
                                }}
                            >
                                Delete Account{" "}
                                {registering && (
                                    <i className="fa fa-spinner fa-spin" />
                                )}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}